import { extendTheme } from '@chakra-ui/react';

const theme = {
    config: {
        initialColorMode: "light",
        useSystemColorMode: false,
    },
    fonts: {
        body: "urw-form, sans-serif",
        heading: "adelle, serif"
    },
    styles: {
        global: {
            a: {
                color: 'blue.500',
                _hover: {
                    textDecoration: 'none',
                    color: 'blue.200'
                }
            },
            p: {
                fontSize: '1.125rem',
                fontFamily: 'urw-form, sans-serif',
                color: 'gray.700',
                marginBottom: '1rem',
            },
            h1: {
                fontSize: 'clamp(2rem, 10vw, 4rem)',
                fontWeight: 900,
                color: 'blue.500',
                marginBottom: '1rem',
                fontFamily: 'adelle, serif'
            },
            h2: {
                fontSize: 'clamp(1.5rem, 4vw, 3rem)',
                fontWeight: 900,
                color: 'blue.600',
                marginBottom: '1rem',
                fontFamily: 'adelle, serif',
                textAlign: 'center'
            },
            h3: {
                fontSize: "2xl",
                fontWeight: 900,
                marginBottom: '0.1255rem',
                fontFamily: 'urw-form, sans-serif'
            },
            h4: {
                fontSize: "xl",
                fontWeight: 900,
                marginBottom: '1rem',
                fontFamily: 'adelle, serif'
            },
            h5: {
                fontSize: "clamp(1.5rem, 3vw, 2.8rem)",
                fontWeight: 900,
                marginBottom: '1rem',
                fontFamily: 'adelle, serif'
            },
            ul: {
                fontSize: '1.125rem',
                fontFamily: 'urw-form, sans-serif',
                color: 'gray.700',
                marginBottom: '1.5rem',
                marginLeft: '1.5rem'
            },
            ol: {
                fontSize: '1.125rem',
                fontFamily: 'urw-form, sans-serif',
                color: 'gray.700',
                marginBottom: '1.5rem',
                marginLeft: '1.5rem'
            }
        }
    },
    components: {
        Text: {
            baseStyle: {
                fontSize: '1.125rem',
                fontFamily: 'urw-form, sans-serif',
                color: 'gray.700',
                marginBottom: '1rem',
            },
            variants: {
                'body-blue': {
                    fontSize: '1rem',
                    fontFamily: 'urw-form, sans-serif',
                    color: 'blue.500',
                },
                'body-green': {
                    fontSize: '1rem',
                    fontFamily: 'urw-form, sans-serif',
                    color: 'green-haze.500',
                },
                'footer-text': {
                    color: 'white',
                    fontSize: '1.125rem',
                    fontFamily: 'Open Sans',
                    fontWeight: 700
                }
            },
        },
        Link: {
            baseStyle: {
                color: 'blue.500',
                fontFamily: 'urw-form, sans-serif',
                fontSize: '1.125rem',
            },
            variants: {
                'nav-item': {
                    color: 'white',
                    fontWeight:700,
                    fontSize: '1.25rem',
                    _hover: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    },
                    active: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    }
                },
                'sub-nav-item': {
                    color: 'white',
                    fontWeight:700,
                    fontSize: '1rem',
                    _hover: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    },
                    active: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    }
                },
                'mobile-nav-item': {
                    color: 'blue.600',
                    fontWeight:700,
                    fontSize: '1.375rem',
                    textAlign: 'center',
                    _hover: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    },
                    active: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    }
                },
                'mobile-sub-nav-item': {
                    color: 'blue.600',
                    fontWeight:700,
                    fontSize: '1rem',
                    _hover: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    },
                    active: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    }
                },
                'footer-link': {
                    color: 'white',
                    fontWeight: 400,
                    fontSize: '1.125rem',
                    display: 'block',
                    _hover: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    },
                    active: {
                        color: 'vintage-yellow.500',
                        textDecoration: 'none'
                    }
                }
            }
        },
        FormLabel: {
            baseStyle: {
                fontSize: '1.125rem',
            },
        },
        Button: {
            variants: {
                'outline' : {
                    _hover: {
                        color: 'blue.500 !important',
                    },
                    _active: {
                        color: 'blue.500 !important',
                    }
                },
                'Blue': {
                    bgColor: 'blue.500',
                    color: 'white',
                    _hover: {
                        bgColor: 'blue.600',
                    },
                    _active: {
                        bgColor: 'blue.600',
                    }
                },
                'Green': {
                    bgColor: 'bold-green.500',
                    color: 'white',
                    _hover: {
                        bgColor: 'bold-green.600',
                    },
                    _active: {
                        bgColor: 'bold-green.600',
                    }
                },
                'Yellow': {
                    bgColor: 'vintage-yellow.500',
                    color: 'white',
                    _hover: {
                        bgColor: 'vintage-yellow.400',
                    },
                    _active: {
                        bgColor: 'vintage-yellow.400',
                    }
                },
                'Orange': {
                    bgColor: 'poppy.500',
                    color: 'white',
                    _hover: {
                        bgColor: 'poppy.400',
                    },
                    _active: {
                        bgColor: 'poppy.400',
                    }
                },
                'tab-button': {
                    fontSize: '2rem'
                }
            }
        },
        Heading: {
            baseStyle: {
              fontWeight: "500"
            },
            variants: {
                'h1': {
                    fontSize: 'clamp(2rem, 5vw, 4rem)',
                    fontWeight: 900,
                    color: 'blue.600',
                    marginBottom: '1rem',
                },
                'h2': {
                    fontSize: 'clamp(1.5rem, 4vw, 3rem)',
                    fontWeight: 900,
                    color: 'blue.600',
                    marginBottom: '1rem',
                    fontFamily: 'adelle, serif',
                    textAlign: 'center'
                },
                'h5': {
                    fontSize: "clamp(1.5rem, 3vw, 2.8rem)",
                    fontWeight: 900,
                    marginBottom: '1rem',
                    fontFamily: 'adelle, serif'
                },
            }
        }
},
    colors: {
        'blue': {
            '50': '#5FC4FF',
            '100': '#4ABDFF',
            '200': '#21AEFF',
            '300': '#009DF8',
            '400': '#0083CF',
            '500': '#0069A6',
            '600': '#00466E',
            '700': '#002236',
            '800': '#000000',
            '900': '#000000'
          },
        'sage': {
            '50': '#E0EBE3',
            '100': '#D3E3D8',
            '200': '#BAD3C2',
            '300': '#A2C3AB',
            '400': '#89B395',
            '500': '#70A37F',
            '600': '#568564',
            '700': '#40634A',
            '800': '#2A4131',
            '900': '#141F17'
            },
        'bold-green': {
            '50': '#74E79A',
            '100': '#63E48D',
            '200': '#40DE74',
            '300': '#24D25D',
            '400': '#1EAF4D',
            '500': '#188C3E',
            '600': '#105C29',
            '700': '#082C14',
            '800': '#000000',
            '900': '#000000'
            },
        'poppy': {
            '50': '#FDA572',
            '100': '#FD985E',
            '200': '#FD7F36',
            '300': '#FC650D',
            '400': '#DE5302',
            '500': '#B64402',
            '600': '#7F2F01',
            '700': '#471B01',
            '800': '#100600',
            '900': '#000000'
            },
        'vintage-yellow': {
            '50': '#FBECB1',
            '100': '#FAE79E',
            '200': '#F7DE77',
            '300': '#F5D550',
            '400': '#F3CB2A',
            '500': '#E7BC0D',
            '600': '#B2910A',
            '700': '#7D6607',
            '800': '#483A04',
            '900': '#130F01'
            },

    },
}

export default extendTheme(theme);